import request from '@/util/request';

//获取系统字典
export const getDictionary = (code, options) =>
  request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));
//获取项目字典
export const getBisDictData = (params, options) =>
    request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

//获取巡检标准管理分页
export const getInspectPage = (params, options) =>
    request.get('/api/v4ward/general/inspect/page', Object.assign({}, options, { params }));

//巡检标准新增

    export const standardGroupSave = (params, options) =>
    request.post('/api/v4ward/general/inspect/standardGroupSave', params,options)
//巡检标准查看
export const standardGroupDetail = (params, options) =>
    request.get('/api/v4ward/general/inspect/standardGroupDetail', Object.assign({}, options, { params }));

//巡检标准编辑
export const standardGroupSubmit = (params, options) =>
request.post('/api/v4ward/general/inspect/standardGroupSubmit', params,options)

//巡检标准删除
export const standardGroupRemove = (id) =>
request.post('/api/v4ward/general/inspect/standardGroupRemove?ids='+id)
//巡检标准停用
export const startToStop = (params, options) =>
request.post('/api/v4ward/general/inspect/startToStop',params, options)

//查看已关联的班组
export const lookStandardGroup = (params, options) =>
    request.get('/api/v4ward/general/inspect/lookStandardGroup', Object.assign({}, options, { params }));

//巡查标准管理移除全部/选中
export const removeGroup = (params, options) =>
request.post('/api/v4ward/general/inspect/removeGroup',params, options)

//查询班组
export const groupPage = (params, options) =>
request.get('/api/v4ward/general/inspect/groupPage', Object.assign({}, options, { params }))

//关联选中的班组
export const relationGroup = (params, options) =>
request.post('/api/v4ward/general/inspect/relationGroup',params, options)


//综合巡查列表记录
export const taskListPage = (params, options) =>
request.get('/api/v4ward/general/task/page', Object.assign({}, options, { params }))

//根据巡查类型获取标准
export const getStandardName = (params, options) =>
request.get('/api/v4ward/general/inspect/getStandardName', Object.assign({}, options, { params }))

//根据标准id获取标准
export const getStandardById = (params, options) =>
request.get('/api/v4ward/general/task/getStandardByStandardId', Object.assign({}, options, { params }))


//新增记录保存
export const saveGeneral = (params, options) =>
request.post('/api/v4ward/general/task/saveGeneral',params, options)

//记录详情
export const taskGeneralDetail = (params, options) =>
request.get('/api/v4ward/general/task/taskGeneralDetail', Object.assign({}, options, { params }))

//记录详情
export const taskGeneralSubmit = (params, options) =>
request.post('/api/v4ward/general/task/taskGeneralSubmit',params, options)

//删除记录
export const taskGeneralRemove = (id) =>
request.post('/api/v4ward/general/task/taskGeneralRemove?ids='+id)


// 获取服务类型列表
export const modulesSetting = (projectId) =>
    request.get('/api/v4ward/ordersetting/setting/modules/' + projectId)

export const relationArea = (params, options) =>
request.get('/api/v4ward/plan/relationArea', Object.assign({}, options, { params }))
